export default {
  namespaced: true,
  state: {
    locations: [],
  },
  getters: {
    /**
     * Returns a list of locations with only the id and name properties.
     * @param {Object} state - The module state.
     * @returns {Array} - A list of locations.
     */
    locationsArr: state => state.locations.map(location => ({
      id: location.id,
      name: location.name,
    }), []),
    /**
     * Returns the number of locations.
     * @param {Object} state - The module state.
     * @returns {Number} - The number of locations.
     */
    locationsCount: state => state.locations.length ?? 0,
  },
  actions: {
    // get locations from thr api

  },
  mutations: {
    /**
     * Sets the locations.
     * @param {Object} state - The module state.
     * @param {Array} data - The locations.
     */
    setLocations(state, data) {
      // eslint-disable-next-line no-param-reassign
      state.locations = data;
    },
    /**
     * Clears the locations.
     * @param {Object} state - The module state.
     */
    clearLocations(state) {
      // eslint-disable-next-line no-param-reassign
      state.locations = [];
    },
  },
};
